export default __webpack_public_path__ + "static/media/no-image.7dfc9f4c.svg";